module.exports = __webpack_public_path__ + "images/marketing/peeps/martin_sachs.jpg";